module.exports = __webpack_public_path__ + "static/scale-model-of-cleveland-metroparks-zoo-in-cleveland-ohio-a75eedb4d97a3b10b58a0488ca4ff80c.png";